export function mountOn(selector, loader, { visibleOnly = false, rootMargin = '150px' } = {}) {
  const nodes = Array.from(document.querySelectorAll(selector));
  if (!nodes.length) return;

  let loaded = false;
  const runOnce = () => {
    if (loaded) return;
    loaded = true;
    loader(nodes);
  };

  if (!visibleOnly) {
    runOnce();
    return;
  }

  const observer = new IntersectionObserver((entries, obs) => {
    for (const e of entries) {
      if (e.isIntersecting) {
        obs.disconnect();
        runOnce();
        break;
      }
    }
  }, { rootMargin });

  nodes.forEach((n) => observer.observe(n));
}